var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.392,
    height: 34.392,
    viewBox: "0 0 34.392 34.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189801",
    "data-name": "Group 189801",
    transform: "translate(-909 -190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_42725",
    "data-name": "Path 42725",
    transform: "translate(909 190)",
    fill: "#ececec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 33.3916015625 C 12.86974048614502 33.3916015625 8.802620887756348 31.70694160461426 5.743640899658203 28.6479606628418 C 2.684660673141479 25.58898162841797 1.000000834465027 21.52186012268066 1.000000834465027 17.19580078125 C 1.000000834465027 12.86974048614502 2.684660673141479 8.802620887756348 5.743640899658203 5.743640899658203 C 8.802620887756348 2.684660673141479 12.86974048614502 1.000000834465027 17.19580078125 1.000000834465027 C 21.52186012268066 1.000000834465027 25.58898162841797 2.684660673141479 28.6479606628418 5.743640899658203 C 31.70694160461426 8.802620887756348 33.3916015625 12.86974048614502 33.3916015625 17.19580078125 C 33.3916015625 21.52186012268066 31.70694160461426 25.58898162841797 28.6479606628418 28.6479606628418 C 25.58898162841797 31.70694160461426 21.52186012268066 33.3916015625 17.19580078125 33.3916015625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.19580078125 2 C 13.13685035705566 2 9.320850372314453 3.58064079284668 6.450750350952148 6.450750350952148 C 3.58064079284668 9.320850372314453 2 13.13685035705566 2 17.19580078125 C 2 21.25475120544434 3.58064079284668 25.07075119018555 6.450750350952148 27.94085121154785 C 9.320850372314453 30.81096076965332 13.13685035705566 32.3916015625 17.19580078125 32.3916015625 C 21.25475120544434 32.3916015625 25.07075119018555 30.81096076965332 27.94085121154785 27.94085121154785 C 30.81096076965332 25.07075119018555 32.3916015625 21.25475120544434 32.3916015625 17.19580078125 C 32.3916015625 13.13685035705566 30.81096076965332 9.320850372314453 27.94085121154785 6.450750350952148 C 25.07075119018555 3.58064079284668 21.25475120544434 2 17.19580078125 2 M 17.19580078125 0 C 26.69278144836426 0 34.3916015625 7.698820114135742 34.3916015625 17.19580078125 C 34.3916015625 26.69278144836426 26.69278144836426 34.3916015625 17.19580078125 34.3916015625 C 7.698820114135742 34.3916015625 0 26.69278144836426 0 17.19580078125 C 0 7.698820114135742 7.698820114135742 0 17.19580078125 0 Z",
    stroke: "none",
    fill: "#e4e3e3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-hourglass",
    "data-name": "Icon ionic-ios-hourglass",
    d: "M16.542,15.921h-.165c-.21,0-.388-.029-.41-.239v0C15.5,11.288,12.73,11.2,12.73,10.17S15.5,9.053,15.967,4.662v0c.023-.21.2-.239.41-.239h.165a.463.463,0,0,0,.465-.43.453.453,0,0,0-.452-.475H6.23a.463.463,0,0,0-.465.43.453.453,0,0,0,.452.475h.178c.21,0,.388.029.41.239v0c.472,4.39,3.237,4.474,3.237,5.508s-2.768,1.118-3.237,5.508v0c-.023.21-.2.239-.41.239H6.23a.463.463,0,0,0-.465.43.453.453,0,0,0,.452.475H16.555a.451.451,0,0,0,.452-.475A.463.463,0,0,0,16.542,15.921Zm-8.15-1.1c.927-2.578,2.571-2.265,2.571-3.282v-1.8c0-.627-1.189-1.063-1.932-2.08a.253.253,0,0,1,.21-.4h4.293a.252.252,0,0,1,.216.394c-.73,1.021-1.941,1.46-1.941,2.087v1.8c0,1.008,1.58.733,2.578,3.282.09.229.023.517-.223.517H8.614C8.365,15.333,8.307,15.048,8.391,14.816Z",
    transform: "translate(915.235 197.484)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_251",
    "data-name": "Ellipse 251",
    transform: "translate(909 194)",
    fill: "#f26e14",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconReview);
export default __webpack_public_path__ + "static/media/notification-icon-review.c9f1423b7c0914a126774d30c6db9f37.svg";
export { ForwardRef as ReactComponent };